import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { ProductCategoryDto } from '../types/dtos';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.mutation<void, { id: string; payload: Partial<ProductCategoryDto> }>({
        query: ({ id, payload }) => ({
            url: `${APP_ENDPOINTS.PRODUCT_CATEGORY}/${id}`,
            method: 'PATCH',
            body: payload,
        }),
        invalidatesTags: [
            { type: 'product-category', id: 'GET-ID' },
            { type: 'product-categories-with-join', id: 'GET-JOIN' },
        ],
    });
